export const relationshipsProjectCustomerHostContributionId = 'relationships.web.projects.customer-panel';
export const relationshipsConsumedProjectsDetailHostCapability = 'projects.detail-host.v1';
export const relationshipsConsumedProjectsDetailSummarySlot = 'projects.detail.summary';
//# sourceMappingURL=relationships-project-customer.contract.js.map